import { PaginacaoNest } from "@/types/pagincacao-nest";
import { Usuario } from "./usuario";

export class ResponseUsuario extends PaginacaoNest {
  usuarios: Usuario[];

  constructor(obj?: any) {
    super(obj.meta)
    if (obj) {
      this.usuarios = obj.data.map(u => new Usuario(u))
    }
  }
}